
import { z } from "zod";

export const FinancingStatusValues = ["APPROVED", "CANCELLED", "CREATED", "DECLINED", "DOCUMENTS_NEEDED", "ESTIMATED", "EXPIRED", "FINALIZED", "FULLY_DISBURSED", "INITIALIZATION_FAILED", "INITIALIZING", "LOAN_DOCUMENTS_SENT", "LOAN_DOCUMENTS_SIGNED", "PARTIALLY_DISBURSED", "PENDING_REVIEW", "PROBLEM", "SENDING_LOAN_DOCUMENTS", "SUBMITTING"] as const;
export const FinancingStatusSchema = /* @__PURE__ */ z.enum(FinancingStatusValues);
export const FinancingStatus: (typeof FinancingStatusSchema)["enum"] = { "APPROVED": "APPROVED", "CANCELLED": "CANCELLED", "CREATED": "CREATED", "DECLINED": "DECLINED", "DOCUMENTS_NEEDED": "DOCUMENTS_NEEDED", "ESTIMATED": "ESTIMATED", "EXPIRED": "EXPIRED", "FINALIZED": "FINALIZED", "FULLY_DISBURSED": "FULLY_DISBURSED", "INITIALIZATION_FAILED": "INITIALIZATION_FAILED", "INITIALIZING": "INITIALIZING", "LOAN_DOCUMENTS_SENT": "LOAN_DOCUMENTS_SENT", "LOAN_DOCUMENTS_SIGNED": "LOAN_DOCUMENTS_SIGNED", "PARTIALLY_DISBURSED": "PARTIALLY_DISBURSED", "PENDING_REVIEW": "PENDING_REVIEW", "PROBLEM": "PROBLEM", "SENDING_LOAN_DOCUMENTS": "SENDING_LOAN_DOCUMENTS", "SUBMITTING": "SUBMITTING" };
export type FinancingStatus = (typeof FinancingStatusValues)[number];
export const FinancingStatusDisplayNames = { "APPROVED": "Approved",
"CANCELLED": "Cancelled",
"CREATED": "Created",
"DECLINED": "Declined",
"DOCUMENTS_NEEDED": "Documents needed",
"ESTIMATED": "Estimated",
"EXPIRED": "Expired",
"FINALIZED": "Finalized",
"FULLY_DISBURSED": "Disbursed",
"INITIALIZATION_FAILED": "Initialization failed",
"INITIALIZING": "Initializing",
"LOAN_DOCUMENTS_SENT": "Loan documents sent",
"LOAN_DOCUMENTS_SIGNED": "Loan documents signed",
"PARTIALLY_DISBURSED": "Partially disbursed",
"PENDING_REVIEW": "Pending review",
"PROBLEM": "Problem",
"SENDING_LOAN_DOCUMENTS": "Sending loan documents",
"SUBMITTING": "Submitting", } satisfies Record<FinancingStatus, string>;
